
<div class="mainContent">
  <div style="height: 7vh;">
    <div>
      <label i18n="@@spmsUserReg"
             class="textColour"
             [ngStyle]="{'border-color': backgroundColorButton}">
        Password Reset Policy Settings
      </label>
    </div>
  </div>

  <div style="height: 57vh;overflow: auto;padding-left: 4%;padding-right: 4%;">
    <form novalidate [formGroup]="FormValid">
      <!-- <div class="row" style="margin-top: 10px;">
        <div class="col-lg-8">
           <mat-slide-toggle  formControlName="disableallrules"name="disableAllRules">
             Disable All Rules
           </mat-slide-toggle>
        </div>
      </div> -->
      <div class="row" style="margin-top: 10px;">
         <div class="col-lg-8">
            <mat-form-field appearance="outline">
              <mat-label>Company Name</mat-label>
              <mat-select formControlName="companyname"  required
                (selectionChange)="companyNameChange($event.value)"  [disabled]="isEditMode">
                <mat-option *ngFor="let obj of companyData" [value]="obj.compname">
                  {{obj.compname}}</mat-option>
              </mat-select>
              <mat-error *ngIf="FormValid.get('lockoutUnit')?.hasError('required')">Unit is required</mat-error>
           </mat-form-field>
        </div>
      </div>

      <div class="row" style="margin-top: 15px;">
        <div class="col-lg-8">
          <mat-form-field appearance="outline">
            <mat-label>Retry Limits for password reset</mat-label>
            <input matInput type="number"
                  
                   name="resetlimit"formControlName="resetlimit"
                   placeholder="Retry Limits for password reset"
                    [disabled]="passwordPolicy.disableallrules">
                 <mat-error *ngIf="FormValid.get('resetlimit')?.hasError('min')">
                 Retry limit must be greater > = 5
                </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row" style="margin-top: 5px;">
        <div class="col-lg-8">
          <mat-form-field appearance="outline">
            <mat-label>Compare No of Last Passwords</mat-label>
            <input matInput type="number"
                  
                   name="lastpasswordchecking"formControlName="lastpasswordchecking"
                   placeholder="Number of Passwords" 
                    [disabled]="passwordPolicy.disableallrules">
                     <mat-error *ngIf="FormValid.get('lastpasswordchecking')?.hasError('min')">
                 Compare No of Last Passwords must be greater > = 5
                </mat-error>
            </mat-form-field>
        </div>
      </div>

      <div class="row" style="margin-top: 10px;">
        <div class="col-lg-8">
         <mat-checkbox [(ngModel)]="passwordPolicy.passwrodcomparisionwithusername" name="passwrodcomparisionwithusername"  [disabled]="passwordPolicy.disableallrules">
             Restrict username in password
         </mat-checkbox>
        </div>
      </div>

      <!-- <div class="row" style="margin-top: 10px;">
        <div class="col-lg-8">
         <mat-checkbox [(ngModel)]="passwordPolicy.masterbypass" name="masterBypass"  [disabled]="passwordPolicy.disableallrules">
            Master Bypass
        </mat-checkbox>
        </div>
      </div> -->

       <!-- <div class="row" style="margin-top: 10px;">
        <div class="col-lg-8">
         <mat-checkbox [(ngModel)]="passwordPolicy.duplicatepassord"
                            name="duplicatepassord"  [disabled]="passwordPolicy.disableallrules">
            Duplicate password
          </mat-checkbox>
        </div>
      </div> -->
      
      <div class="row" style="margin-top: 5px;">
        <div class="col-lg-8">
          <mat-form-field appearance="outline">
            <mat-label>Password Expiry Period</mat-label>
            <input matInput type="number"
                  
                   name="passwordexpirycycle"formControlName="passwordexpirycycle"
                   placeholder="Number of days password should expiry" 
                    [disabled]="passwordPolicy.disableallrules" required>
                     <mat-error *ngIf="FormValid.get('passwordexpirycycle')?.hasError('min')">
                       Password Expiry period must be  > = 30
                </mat-error>
            </mat-form-field>
        </div>
      </div>

       <!-- <div class="row" style="margin-top: 10px;">
        <div class="col-lg-8">
         <mat-checkbox [(ngModel)]="passwordPolicy.expiry"
                            name="expiry"  [disabled]="passwordPolicy.disableallrules">
            Expiry
          </mat-checkbox>
        </div>
      </div>

       <div class="row" style="margin-top: 5px;" *ngIf="passwordPolicy.expiry">
        <div class="col-lg-8">
          <mat-form-field appearance="outline">
            <mat-label>Expiry Date</mat-label>
          <input matInput [matDatepicker]="picker" [(ngModel)]="passwordPolicy.expirydate">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>
      </div>
 -->

     <div class="row" style="margin-top: 10px;">
  <div class="col-lg-8">
    <mat-checkbox  formControlName="lockoutenabled" name="lockoutenabled" [disabled]="passwordPolicy.disableallrules">
      Lock out time for reset
    </mat-checkbox>
    <mat-error *ngIf="FormValid.get('lockoutenabled')?.hasError('required')">
  Lockout must be enabled when Reset Limit > 0
</mat-error>

  </div>
</div>

<div class="row" style="margin-top: 5px" *ngIf="FormValid.get('lockoutenabled')?.value" >
  <div class="col-lg-4">
    <mat-form-field appearance="outline">
      <mat-label>Lockout Duration</mat-label>
      <input matInput type="number" formControlName="lockoutvalue"  name="lockoutvalue">
       <mat-error *ngIf="FormValid.get('lockoutvalue')?.hasError('required')">Lockout duration is required</mat-error>
      <mat-error *ngIf="FormValid.get('lockoutvalue')?.hasError('min')">Minimum value is 1</mat-error>
    </mat-form-field>
  </div>
  <div class="col-lg-4">
    <mat-form-field appearance="outline">
      <mat-label>Unit</mat-label>
      <mat-select  name="lockoutUnit" formControlName="lockoutUnit">
        <mat-option value="SECONDS">Seconds</mat-option>
        <mat-option value="MINUTES">Minutes</mat-option>
        <mat-option value="HOURS">Hours</mat-option>
        <!-- <mat-option value="DAYS">Days</mat-option> -->
      </mat-select>
       <mat-error *ngIf="FormValid.get('lockoutUnit')?.hasError('required')">Unit is required</mat-error>
    </mat-form-field>
  </div>
</div>  


    </form>
  </div>
  <div style="height:5vh">
      <div class="row" style= "position:sticky;left:0;bottom:0;width:100%;">

        <div class="col-lg text-center">

          <div style="text-align: end;">

            <button i18n="@@TargetClear" type="button" (click)="openSaveForm()"
                    class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton"
                    style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;">{{this.buttonName}}</button>

            <button i18n="@@TargetCancel" type="button" (click)="cancel()"
                    class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton"
                    style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;">Cancel</button>
          </div>
        </div>
      </div>
    </div>
</div>
